import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  NgxScannerQrcodeComponent,
  ScannerQRCodeDevice,
  ScannerQRCodeResult,
} from 'ngx-scanner-qrcode';
import { concat, Observable, of, Subject } from 'rxjs';

import { LocationService } from '@app/core/locations/services/location.service';
import { WarehouseScanService } from '@app/core/scanner/services/warehouse-scan.service';

@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss'],
})
export class ScannerComponent implements OnInit, AfterViewInit {
  @ViewChild(NgxScannerQrcodeComponent, { static: false })
  scanner :NgxScannerQrcodeComponent;
  @Input() onScanSuccess :(result :ScannerQRCodeResult[]) => void;
  @Input() autoPlay :boolean = false;
  @Output() scanSuccess :EventEmitter<ScannerQRCodeResult[]> = new EventEmitter<
    ScannerQRCodeResult[]
  >();
  location$ :Observable<any[]>;
  isLoading :boolean = false;
  locationInput$ :Subject<string> = new Subject<string>();
  scannedValue = '';
  scannerConfig = {
    fps: 1,
    vibrate: 300,
    isBeep: true,
    deviceActive: '',
    constraints: { audio: false, video: true },
  };

  selectedDevice :string | null = null;
  shouldBeep = true;

  constructor(
    private router :Router,
    private changeDetector :ChangeDetectorRef,
    private locationSvc :LocationService,
    private scannerService :WarehouseScanService,
  ) {}
  ngOnInit() {
    const storedDevice = localStorage.getItem('selectedDevice');
    if (storedDevice) {
      this.scannerConfig.deviceActive = storedDevice;
    }
  }
  ngAfterViewInit() {
    if (this.autoPlay) {
      this.openScanner();
    }
  }

  async onSelectDevice($event :any) :Promise<void> {
    this.selectedDevice = $event;
    localStorage.setItem('selectedDevice', $event);
    this.scannerConfig.deviceActive = $event;

    await this.scanner.playDevice($event).toPromise();
    this.changeDetector.detectChanges();
  }
  onScanned(result :ScannerQRCodeResult[]) :void {
    this.shouldBeep = false;
    //If result.typeName = "ZBAR_EAN13" and the first character is a 0, remove the 0.  It is a UPC-A code.
    if (result[0].typeName === 'ZBAR_EAN13' && result[0].value.charAt(0) === '0') {
      result[0].value = result[0].value.substring(1);
    }
    if (!result || result.length <= 0) {
      return;
    }

    if (this.scannedValue === result[0].value) {
      return;
    }
    this.scannedValue = result[0].value;

    this.isLoading = true;
    this.scannerService.getScannerData(this.scannedValue).subscribe(
      (data) => {
        data.scannedValue = this.scannedValue;
        this.shouldBeep = true;
        if (this.scanSuccess) {
          this.scanSuccess.emit(data);
        }
        this.isLoading = false;
      },
      (error) => {
        this.shouldBeep = true;
        this.isLoading = false;
      },
    );
  }
  async openScanner() :Promise<void> {
    await this.scanner.start().toPromise();
    this.changeDetector.detectChanges();
    if (this.scannerConfig.deviceActive) {
      await this.onSelectDevice(this.scannerConfig.deviceActive);
    }
  }

  confirmScan() {
    // Navigate to the next step with the scanned code
    this.router.navigate(['/sku-selection'], { queryParams: { location: '' } });
  }
}
